import { render, staticRenderFns } from "./multipleMarubatsu2.vue?vue&type=template&id=70e68871&scoped=true"
import script from "./multipleMarubatsu2.vue?vue&type=script&lang=ts"
export * from "./multipleMarubatsu2.vue?vue&type=script&lang=ts"
import style0 from "./multipleMarubatsu2.vue?vue&type=style&index=0&id=70e68871&prod&scoped=true&lang=css"
import style1 from "./multipleMarubatsu2.vue?vue&type=style&index=1&id=70e68871&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e68871",
  null
  
)

export default component.exports